import { NgModule } from '@angular/core';

import { DownloadModule } from './download/download.module';
import { UploadModule } from './upload/upload.module';

@NgModule({
  exports: [UploadModule, DownloadModule]
})
export class FileTransfertModule {}
